import { render, staticRenderFns } from "./yhxy.vue?vue&type=template&id=19bb5991&scoped=true&"
import script from "./yhxy.vue?vue&type=script&lang=js&"
export * from "./yhxy.vue?vue&type=script&lang=js&"
import style0 from "./yhxy.vue?vue&type=style&index=0&id=19bb5991&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb5991",
  null
  
)

export default component.exports